var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTag2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.4375H1.5C1.1925 1.4375 0.9375 1.1825 0.9375 0.875C0.9375 0.5675 1.1925 0.3125 1.5 0.3125H16.5C16.8075 0.3125 17.0625 0.5675 17.0625 0.875C17.0625 1.1825 16.8075 1.4375 16.5 1.4375Z",
    fill: "#0044EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75391 0.875V9.8525C2.75391 10.5875 3.09891 11.285 3.69141 11.7275L7.59891 14.6525C8.43141 15.275 9.57891 15.275 10.4114 14.6525L14.3189 11.7275C14.9114 11.285 15.2564 10.5875 15.2564 9.8525V0.875H2.75391ZM12.0014 9.3125H6.00141C5.69391 9.3125 5.43891 9.0575 5.43891 8.75C5.43891 8.4425 5.69391 8.1875 6.00141 8.1875H12.0014C12.3089 8.1875 12.5639 8.4425 12.5639 8.75C12.5639 9.0575 12.3089 9.3125 12.0014 9.3125ZM12.0014 5.5625H6.00141C5.69391 5.5625 5.43891 5.3075 5.43891 5C5.43891 4.6925 5.69391 4.4375 6.00141 4.4375H12.0014C12.3089 4.4375 12.5639 4.6925 12.5639 5C12.5639 5.3075 12.3089 5.5625 12.0014 5.5625Z",
    fill: "#0044EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag2);
export default __webpack_public_path__ + "static/media/icon_tag_2.022693ef8d779cb6b780cb2623fbb4f5.svg";
export { ForwardRef as ReactComponent };